import React from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import i18n from 'i18n';
import { BlockDurationSelectProps } from 'modules/environments/interfaces';
import styles from './styles';

export const InstanceBlockDuration = ({
  value = 30,
  onChange,
  notifyUsers = false,
  onChangeNotifyUsers,
}: BlockDurationSelectProps) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});

  const options = [5, 15, 30, 60];

  const [duration, setDuration] = React.useState(value);
  const [notify, setNotify] = React.useState(notifyUsers);

  React.useEffect(() => {
    setDuration(value);
  }, [value]);

  React.useEffect(() => {
    setNotify(notifyUsers);
  }, [notifyUsers]);

  const handleChangeDuration = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const next = Number(event.target.value);
    setDuration(next);
    onChange(next);
  };

  const handleChangeNotifyUsers = (checked: boolean) => {
    setNotify(checked);
    if (onChangeNotifyUsers) {
      onChangeNotifyUsers(checked);
    }
  };

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid item>
        <Typography className={classes.label}>
          {i18n.t('ENVIRONMENTS_PAGE.BLOCK_DURATION_LABEL')}
        </Typography>
      </Grid>
      <Grid item>
        <Select
          value={duration}
          onChange={handleChangeDuration}
          variant="outlined"
          className={classes.select}
        >
          {options.map(option => (
            <MenuItem
              key={option}
              value={option}
              className={classes.selectItem}
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              id="notify-users"
              size="small"
              checked={notify}
              onChange={event => handleChangeNotifyUsers(event.target.checked)}
            />
          }
          label={
            <Typography className={classes.label}>
              {i18n.t('ENVIRONMENTS_PAGE.NOTIFY_USERS_LABEL')}
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
};
